import { DESTINATION_ROOT_PATH_PLACEHOLDER, GET_DESTINATIONS_BY_PARTNER_PATH, PARTNER_PATH_PLACEHOLDER, } from '@yme/components/Destinations/PartnerRelatedExperiences/constants';
export function isPartnerRelatedExperiencesEmpty(props) {
    return !props.experiencesRootPath || !props.edpURL || !props.experienceListingPagePath;
}
export const buildRequestUrl = (partnerPath, rootPath) => GET_DESTINATIONS_BY_PARTNER_PATH.replace(PARTNER_PATH_PLACEHOLDER, partnerPath).replace(DESTINATION_ROOT_PATH_PLACEHOLDER, rootPath);
